import React, { ComponentProps, FC } from 'react';
// mui
import { Grid, InputAdornment } from '@mui/material';
// components
import NumericFormatInputController from 'controllers/numeric-format-input-controller';
// icons
import DollarIcon from 'assets/icons/new/selection/dollar.svg';

interface IProps extends ComponentProps<typeof NumericFormatInputController> {}

const amountInputAdornment = (
  <InputAdornment position="start">
    <Grid item display="flex">
      <DollarIcon />
    </Grid>
  </InputAdornment>
);

const AmountInput: FC<IProps> = ({ name = 'amount', ...props }) => {
  return (
    <NumericFormatInputController
      fullWidth
      withError
      name={name}
      label="Amount"
      placeholder="E.g. 1000"
      startAdornment={amountInputAdornment}
      thousandSeparator=","
      decimalSeparator="."
      decimalScale={2}
      fixedDecimalScale={true}
      allowNegative={false}
      {...props}
    />
  );
};

export default AmountInput;
